import { useDeviceType } from '@cian/ui-kit/responsive';

import {
  CLUSTER_PINS_DESKTOP_MAX_COUNT,
  CLUSTER_PINS_PHONE_MAX_COUNT,
} from '../../../../common/constants/clusterPinsLimits';

// Лимит пинов раскрытого кластера: на мобвебе (phone и tablet) рисуем не больше 7
export function useMaxPinsPerCluster(): number {
  const deviceType = useDeviceType();

  return deviceType === 'desktop' ? CLUSTER_PINS_DESKTOP_MAX_COUNT : CLUSTER_PINS_PHONE_MAX_COUNT;
}
